import { render, staticRenderFns } from "./pdfAndXlxView.vue?vue&type=template&id=e8e1fda2&scoped=true"
import script from "./pdfAndXlxView.vue?vue&type=script&lang=js"
export * from "./pdfAndXlxView.vue?vue&type=script&lang=js"
import style0 from "./pdfAndXlxView.vue?vue&type=style&index=0&id=e8e1fda2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e1fda2",
  null
  
)

export default component.exports